import React from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import { LineChart } from "@mui/x-charts/LineChart";
import { PieChart, axisClasses } from "@mui/x-charts";
import styled from "styled-components";
import { LoadingOverlay, NoDataOverlay } from "./LoadingOverlay";
import { scaleFormatter } from "../../utils/helpers";

type TChartProps = {
  data?: any[];
  xLabels?: any[];
  yLabel?: string;
  xLabel?: string;
  loading?: boolean;
  height?: number;
  title?: string;
};

export const GenericBarChart = ({
  data = [],
  xLabels = [],
  yLabel,
  loading,
  height,
  title,
  xLabel,
}: TChartProps) => (
  <div className="">
    {title && <ChartTitle>{title}</ChartTitle>}
    <BarChart
      series={data}
      xAxis={[
        {
          data: xLabels,
          label: xLabel,
          tickPlacement: "end",
          scaleType: "band",
          labelStyle: { textTransform: "capitalize" },
          tickLabelStyle: { textTransform: "capitalize", fontSize: 12 },
        },
      ]}
      yAxis={[
        {
          label: yLabel,
          labelStyle: { fontSize: 12 },
          valueFormatter: scaleFormatter,
        },
      ]}
      height={height || 350}
      borderRadius={5}
      grid={{ horizontal: true }}
      loading={loading}
      slots={{ loadingOverlay: LoadingOverlay, noDataOverlay: NoDataOverlay }}
      margin={{ left: 60 }}
      sx={{
        [`.${axisClasses.left} .${axisClasses.label}`]: {
          transform: "translate(-15px, 0)",
        },
        "& .MuiChartsLegend-series tspan": { fontSize: "0.8em" },
      }}
    />
  </div>
);

export const GenericLineChart = ({
  data = [],
  xLabels = [],
  yLabel,
  loading,
  height,
  xLabel,
  title,
}: TChartProps) => (
  <div className="x100">
    {title && <ChartTitle>{title}</ChartTitle>}
    <LineChart
      series={data}
      xAxis={[
        {
          data: xLabels,
          label: xLabel,
          tickPlacement: "end",
          scaleType: "band",
          labelStyle: { textTransform: "capitalize" },
          tickLabelStyle: { textTransform: "capitalize", fontSize: 12 },
        },
      ]}
      yAxis={[
        {
          label: yLabel,
          labelStyle: { fontSize: 12 },
          valueFormatter: scaleFormatter,
        },
      ]}
      height={height || 350}
      loading={loading}
      slots={{ loadingOverlay: LoadingOverlay, noDataOverlay: NoDataOverlay }}
      margin={{ left: 60 }}
      sx={{
        [`.${axisClasses.left} .${axisClasses.label}`]: {
          transform: "translate(-15px, 0)",
        },
        "& .MuiChartsLegend-series tspan": { fontSize: "0.8em" },
      }}
    />
  </div>
);

export const GenericPieChart = ({ data }: { data?: any[] }) => {
  if (!data) return <NoDataWrapper>No Data to display</NoDataWrapper>;
  return (
    <PieChart
      series={[
        {
          data,
          highlightScope: { faded: "global", highlighted: "item" },
          faded: { innerRadius: 20, additionalRadius: -20, color: "gray" },
          innerRadius: 30,
          outerRadius: 100,
          paddingAngle: 3,
          cornerRadius: 3,
        },
      ]}
      height={250}
      sx={{ "& .MuiChartsLegend-series tspan": { fontSize: "0.8em" } }}
    />
  );
};

const NoDataWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 0.7em;
`;

const ChartTitle = styled.h3`
  font-size: 01em;
  font-weight: 600;
  // margin: 0;
  // padding-left: 10px;
  text-align: center;
`;
